import React from 'react';
import '../Styles/ResultsPublications.css';
import StarryBackground from '../Pages/StarryBackground.js';

const resultsData = [
  {
    type: 'Conference Paper',
    title: '11.2 GHz Motorized Small Radio Telescope constructed from Satellite TV Dish',
    date: 'December 2024',
    description: 'A conference paper on the Small Radio Telescope, presented at URSI-RCRS 2024.',
    link: '#'
  },
  {
    type: 'Poster',
    title: 'Radio Telescope Project: 5m aperture telescope for Radio Astronomy at IIT Roorkee',
    date: 'April 2023',
    link: 'http://dx.doi.org/10.13140/RG.2.2.13024.35846'
  },
  {
    type: 'Poster',
    title: 'Building a 5m aperture small radio telescope at IIT Roorkee',
    date: 'April 2022',
    link: 'http://dx.doi.org/10.13140/RG.2.2.28701.59365'
  },
  // Add more entries as needed
];

const ResultsPublications = () => {
  return (
    <div className="results-publications">
      <StarryBackground />
      <h1>Results </h1>
      <div className="grid-container">
        {resultsData.map((item, index) => (
          <div className="card" key={index}>
            <div className="card-type">{item.type}</div>
            <h2>{item.title}</h2>
            <p className="date">{item.date}</p>
            <p>{item.description}</p>
            <a href={item.link} className="more-link">Know More</a>
          </div>
        ))}
      </div>
      <div className="resources-section">
        <h3 className='head'>Resources</h3>
        {/* Links for resources can be added here */}
        <ul className="resource-list">
          {/*}
          <li><a href="hello.jg">Link 1</a></li>
          <li><a href="hello.jg">Link 2</a></li>
          <li><a href="hello.jg">Link 3</a></li>
          <li><a href="hello.jg">Link 4</a></li>
          */}
        </ul>
      </div>
    </div>
  );
};

export default ResultsPublications;